/* eslint-disable @typescript-eslint/no-floating-promises */
import merge from 'lodash/merge';
import App from './views/App.svelte';
import AppError from './views/Error.svelte';
import Cancel from './views/Cancel.svelte';
import { DataLoader } from './services/data.loader';
import GroupService from './services/group.service';
import ActivityService from './services/activity.service';
import IndividualFormService from './services/individual-form.service';
import ServiceProvider from './services/service.provider';
import DataProvider from './services/data.provider';
class ReservationApp {
    constructor(options) {
        this.options = options;
    }
    async mount() {
        try {
            this.prepareOptions();
            this.dataProvider = new DataProvider(this.branchId, this.options);
            const loader = new DataLoader(this.dataProvider);
            const individualService = new IndividualFormService(this.dataProvider);
            await loader.load();
            const groupService = new GroupService(loader.groups);
            const activityService = new ActivityService(loader.activities);
            this.serviceProvider = new ServiceProvider(groupService, activityService, individualService);
            this.createInstance();
        }
        catch (e) {
            new AppError({
                target: this.targetElement,
            });
            // console.log(e)
        }
    }
    createInstance() {
        const instance = this.isCancel() ? Cancel : App;
        if (this.isCancel()) {
            this.dataProvider.hash = this.options.hash;
        }
        new instance({
            target: this.targetElement,
            props: {
                serviceProvider: this.serviceProvider,
                dataProvider: this.dataProvider
            }
        });
    }
    get targetElement() {
        const { el } = this.options;
        const element = document.querySelector(el);
        if (null === element) {
            throw new Error("The container for displaying reservation does not exist");
        }
        return element;
    }
    get branchId() {
        const { branchId } = this.options;
        return branchId;
    }
    // OPTIONS
    prepareOptions() {
        this.options = merge({}, {
            el: null,
            branchId: null,
        }, this.options);
    }
    isCancel() {
        return !!(this.options.hash);
    }
}
const appContainer = document.getElementById("reservation-app");
if (appContainer) {
    let reservationParams = {};
    const paramsString = window.location.search;
    const searchParams = new URLSearchParams(paramsString);
    if (searchParams.has("cq")) {
        reservationParams = {
            hash: searchParams.get("cq")
        };
    }
    const branchId = parseInt(appContainer.getAttribute("branch-id"));
    const occupancyCountersId = branchId;
    const osc = appContainer.getAttribute("osc");
    const reservationApp = new ReservationApp(Object.assign({ branchId, osc, occupancyCountersId, el: "#reservation-app" }, reservationParams));
    reservationApp.mount();
}
